function normalizarHost(val) {
  if (val == null || typeof val !== 'string') return '';
  const v = String(val).trim();
  const q = v.replace(/^['"]|['"]$/g, '');
  return q.trim() || v;
}

function urlComProtocolo(val) {
  const v = normalizarHost(val);
  if (!v) return '';
  if (v.toLowerCase().startsWith('https://') || v.toLowerCase().startsWith('http://')) return v;
  return `http://${v}`;
}

export function ensureProtocol(baseUrl) {
  if (baseUrl == null || typeof baseUrl !== 'string') return '';
  const s = baseUrl.trim();
  if (s.toLowerCase().startsWith('https://') || s.toLowerCase().startsWith('http://')) return s;
  if (s === '') return '';
  return `http://${s}`;
}

const envAnalista = process.env.REACT_APP_BACKEND_ANALISTA;
const envSolicitante = process.env.REACT_APP_BACKEND_SOLICITANTE;

const getBackendAnalista = () => normalizarHost(envAnalista) || '';
const getBackendSolicitante = () => normalizarHost(envSolicitante) || '';

function initBackendConfig() {
  const urlAnalista = urlComProtocolo(envAnalista);
  const urlSolicitante = urlComProtocolo(envSolicitante);
  if (urlAnalista) {
    try {
      localStorage.setItem('ipBackend2', urlAnalista);
    } catch (e) {
      console.warn('config/backend: não foi possível definir ipBackend2 no localStorage.', e);
    }
  }
  if (urlSolicitante) {
    try {
      localStorage.setItem('ipBackend', urlSolicitante);
    } catch (e) {
      console.warn('config/backend: não foi possível definir ipBackend no localStorage.', e);
    }
  }
}

function getBaseUrlAnalista() {
  return urlComProtocolo(envAnalista);
}

function getBaseUrlSolicitante() {
  return urlComProtocolo(envSolicitante);
}

export {
  getBackendAnalista,
  getBackendSolicitante,
  getBaseUrlAnalista,
  getBaseUrlSolicitante,
  initBackendConfig,
};
